var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.type,_vm._b({tag:"component"},'component',_vm.props,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }